import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import NavigationScroll from 'layout/navigationScroll';
import { useSelector } from 'react-redux';
import { ReducersModal } from 'utils/modals';
import { USER_ROLE } from 'utils/userType';


const SubAdminRoute = ({ children }: any) => {
    const location = useLocation();
    const { role } = useSelector(
        (state: ReducersModal) => state.AuthReducer
    );

    if (role !== USER_ROLE.SUPER_ADMIN) {
        return <Navigate to='/unauthorized' state={{ from: location }} />;
    }
    return <NavigationScroll>{children}</NavigationScroll>;
};
export default SubAdminRoute;